module.exports = __webpack_public_path__ + "img/ignis-glx.e3b1a46f.png";